/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Form, Row, Col, Button, Accordion, Card } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { map, isEmpty, pickBy, get } from 'lodash';
import * as layerOps from '../../../api/Layers/layer-operations';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import ModalElement from '../../components/ModalElement';
import PaginationComponent from '../../components/Pagination';
import { useStyles } from '../../../styles/mapStylesCustom';

let domainWithoutLastSlash = '';

const NewDBLayerServer = props => {
  const [indexJson, setIndexJson] = React.useState({});
  const [schema, setSchema] = React.useState('');
  const [search, setSearch] = React.useState('');
  const [indexArray, setIndexArray] = React.useState([]);
  const [uniqueSchema, setUniqueSchema] = React.useState([]);
  const [filte, setFilte] = React.useState([]);
  const [elementePage, setElementPage] = React.useState(15);
  const [currentPage, setCurrentPage] = React.useState(1);

  const [metadataLayer, setMetadataLayer] = React.useState({ center: [], bounds: [], tileurl: '' });
  const [previewMapUrl, setPreviewMapUrl] = React.useState('');
  const [modalShow, setModalShow] = React.useState(false);
  const inputDomain = React.useRef('');
  const classes = useStyles();

  const loadIndex = async indexUrlFile => {
    domainWithoutLastSlash = indexUrlFile;
    if (indexUrlFile.charAt(indexUrlFile.length - 1) === '/') {
      domainWithoutLastSlash = indexUrlFile.substr(0, indexUrlFile.length - 1);
    }
    const response = await fetch(`${domainWithoutLastSlash}/index.json`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const data = await response.json();
    setIndexArray(Object.keys(data));
    const unique = [...new Set(map(data, item => item.schema))];
    setUniqueSchema(unique);
    setIndexJson(data);
    setCurrentPage(1);
  };

  const redirectToLayerView = data => {
    const { history } = props;
    // Bert.alert(confirmation, 'success');
    history.push(`/layers/newLoad`, { metadata: data });
  };
  const redirectToLayerViewTab = () => {
    window.open('/layers/newLoad', '_blank');
  };

  const loadDataToSource = data => {
    if (!isEmpty(data.bounds)) {
      redirectToLayerView(data);
    }
  };
  const loadLocalStorage = (data, isModal) => {
    localStorage.setItem('Metadata', JSON.stringify(data));
    if (!isModal) {
      redirectToLayerViewTab();
    } else {
      setModalShow(true);
    }
  };

  const loadMetadataLayer = async (id, but) => {
    const response = await fetch(`${domainWithoutLastSlash}/${id}.json`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const data = await response.json();
    setMetadataLayer(data);
    setPreviewMapUrl(`${domainWithoutLastSlash}/${id}.html`);
    if (but === 'PUSH') {
      loadDataToSource(data);
    } else if (but === 'TAB') {
      data.isModal = false;
      loadLocalStorage(data, false);
    } else if (but === 'Modal') {
      data.isModal = true;
      loadLocalStorage(data, true);
    }
  };
  const changeElementPerPage = event => {
    const value = Number(event.target.value.trim());
    setElementPage(value);
  };
  const handleOnChangeServerList = evt => {
    const domain = evt.target.value;
    loadIndex(domain);
  };
  const handleSearch = event => {
    event.persist();
    setSearch(event.target.value.trim());
    const searchRegex = new RegExp(event.target.value.trim(), 'i');
    const searchRegexSchema = new RegExp(schema, 'i');
    const filteredLayersSchema = pickBy(indexJson, layer =>
      searchRegexSchema.test(get(layer, 'schema', ''))
    );
    const filteredLayers = pickBy(filteredLayersSchema, layer =>
      searchRegex.test(layerOps.getName(layer))
    );
    setIndexArray(Object.keys(filteredLayers));
  };
  const handleSchema = event => {
    event.persist();
    setSchema(event.target.value.trim());
    const searchRegex = new RegExp(search, 'i');
    const searchRegexSchema = new RegExp(event.target.value.trim(), 'i');
    const filteredLayersSchema = pickBy(indexJson, layer =>
      searchRegexSchema.test(get(layer, 'schema', ''))
    );
    const filteredLayers = pickBy(filteredLayersSchema, layer =>
      searchRegex.test(layerOps.getName(layer))
    );
    setIndexArray(Object.keys(filteredLayers));
  };

  React.useEffect(() => {}, [metadataLayer]);

  const { gmsConnections, isAdmin, isPremium } = props;

  return (
    <>
      <Row>
        <Col xs={6}>
          <div className="row">
            <div className="col-12">
              <h4>Database Tile Servers</h4>
              <Form.Group>
                <Form.Control
                  as="select"
                  name="gmsConnection"
                  onChange={event => handleOnChangeServerList(event)}
                >
                  <option value="">-</option>
                  {map(gmsConnections, ({ _id, name, serverType, domain }) => {
                    if (serverType === 'DTS')
                      return (
                        <option value={domain} key={_id}>
                          {name}
                        </option>
                      );
                    return '';
                  })}
                </Form.Control>
              </Form.Group>
            </div>
          </div>
          {(isAdmin || isPremium) && (
            <div className="row">
              <div className="col-10">
                <Form.Control
                  ref={inputDomain}
                  name="DTL-URL"
                  defaultValue="Database Tile Server URL"
                />
              </div>
              <div className="col-2">
                <Button
                  block
                  onClick={() => {
                    loadIndex(inputDomain.current.value);
                  }}
                >
                  Load URL
                </Button>
              </div>
            </div>
          )}

          <br />
          <div className="row">
            <div className="col-12">
              <Row className="m-1" xs={12}>
                <iframe
                  title="Preview Map"
                  className="embed-responsive-item"
                  src={previewMapUrl}
                  style={{ display: 'block', border: 'none', width: '100vw', height: '50vh' }}
                />
              </Row>
            </div>
          </div>
        </Col>
        {isEmpty(indexJson) ? (
          false
        ) : (
          <Col xs={6}>
            <Row>
              <Col xs={4} className="flex-row align-items-center">
                <Form.Control
                  as="select"
                  defaultValue={elementePage}
                  className="mr-sm-2"
                  id="Elements"
                  onChange={event => changeElementPerPage(event)}
                  custom
                >
                  <option value="10">10 Elements per page</option>
                  <option value="15">15 Elements per page</option>
                  <option value="20">20 Elements per page</option>
                  <option value="30">30 Elements per page</option>
                  <option value="60">60 Elements per page</option>
                </Form.Control>
              </Col>
              <Col xs={4} className="flex-row align-items-center">
                <div className="position-relative">
                  <FontAwesomeIcon
                    className="position-absolute"
                    style={{
                      left: '12px',
                      top: '10px'
                    }}
                    color="var(--gray-light)"
                    icon="search"
                  />
                  <Form.Control
                    type="text"
                    name="search"
                    className="pl-5"
                    placeholder="Search Layer"
                    onKeyUp={handleSearch}
                  />
                </div>
              </Col>
              <Col xs={4} className="flex-row align-items-center">
                <Form.Control
                  as="select"
                  defaultValue=""
                  className="mr-sm-2"
                  id="Schema"
                  onChange={event => handleSchema(event)}
                  custom
                >
                  <option value="">-</option>
                  {map(uniqueSchema, value => {
                    return (
                      <option value={value} key={value}>
                        {value}
                      </option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Row>
            <PaginationComponent
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setFilte={setFilte}
              elementePage={elementePage}
              indexArray={indexArray}
              elementPaginttion={11}
            />
            <div className="col-12">
              <Accordion>
                {map(indexJson, ({ name, id }, index) => {
                  if (filte.includes(index)) {
                    return (
                      <Card padding="0px" key={index}>
                        <Card.Header className="py-0">
                          <Row className="align-items-center justify-content-center" xs={12}>
                            <Col sm={6} md={7} lg={8} xl={9}>
                              <Accordion.Toggle
                                as={Card}
                                className="py-0 border-0"
                                style={{ backgroundColor: 'transparent' }}
                                eventKey={id}
                                onClick={() => loadMetadataLayer(id, '')}
                              >
                                {name}
                              </Accordion.Toggle>
                            </Col>
                            <Col sm={6} md={5} lg={4} xl={3}>
                              <Card
                                className="py-0 border-0"
                                style={{ backgroundColor: 'transparent' }}
                              >
                                <div className="text-left">
                                  <Button
                                    className={classes.azulIpsilum}
                                    variant="light"
                                    title="Open"
                                    onClick={() => loadMetadataLayer(id, 'PUSH')}
                                  >
                                    <FontAwesomeIcon icon="file-alt" size="lg" />
                                  </Button>
                                  <Button
                                    className={classes.azulIpsilum}
                                    variant="light"
                                    title="New Tab"
                                    onClick={() => loadMetadataLayer(id, 'TAB')}
                                  >
                                    <FontAwesomeIcon icon={['fa', 'link']} size="sm" />
                                  </Button>
                                  <Button
                                    className={classes.azulIpsilum}
                                    variant="light"
                                    title="Open Modal"
                                    onClick={() => loadMetadataLayer(id, 'Modal')}
                                  >
                                    <FontAwesomeIcon icon={['fa', 'expand-arrows-alt']} />
                                  </Button>
                                </div>
                              </Card>
                            </Col>
                          </Row>
                        </Card.Header>

                        <Accordion.Collapse eventKey={id}>
                          <Card.Body>
                            <Col xs={12}>
                              <h4>Tile Metadata</h4>
                              <div className="row">
                                <div className="col-6">
                                  <Row className="m-1" xs={12}>
                                    <p>ID: {metadataLayer.id}</p>
                                  </Row>
                                  <Row className="m-1" xs={12}>
                                    <p>Schema: {metadataLayer.schema}</p>
                                  </Row>
                                  <Row className="m-1" xs={12}>
                                    <p>Name: {metadataLayer.name}</p>
                                  </Row>
                                  <Row className="m-1" xs={12}>
                                    <p>Geometry Type: {metadataLayer.geometrytype}</p>
                                  </Row>
                                </div>
                                <div className="col-6">
                                  <Row className="m-1" xs={12}>
                                    <p>Center</p>
                                    <ul>
                                      <li>X: {metadataLayer.center[0]}</li>
                                      <li>Y: {metadataLayer.center[1]}</li>
                                    </ul>
                                  </Row>
                                  <Row className="m-1" xs={12}>
                                    <p>Bounds</p>
                                    <ul>
                                      <li>Xmin: {metadataLayer.bounds[0]}</li>
                                      <li>ymin: {metadataLayer.bounds[1]}</li>
                                      <li>Xmax: {metadataLayer.bounds[2]}</li>
                                      <li>Ymax: {metadataLayer.bounds[3]}</li>
                                    </ul>
                                  </Row>
                                </div>
                              </div>
                              <Row className="m-1" xs={12}>
                                <div className="col-12">
                                  <p>Tile URL: {metadataLayer.tileurl}</p>
                                </div>
                              </Row>
                            </Col>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    );
                  }
                  return false;
                })}
              </Accordion>
            </div>
          </Col>
        )}
      </Row>
      <ModalElement
        modalShow={modalShow}
        onHide={() => setModalShow(false)}
        Componet="Layer Load"
        {...props}
      />
    </>
  );
  //  }
};

NewDBLayerServer.defaultProps = {
  gmsConnections: [],
  history: {}
};

NewDBLayerServer.propTypes = {
  gmsConnections: PropTypes.array,
  history: PropTypes.object,
  isPremium: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired
};
export default withTracker(() => {
  const gmsConnectionsSub = Meteor.isClient && Meteor.subscribe('gmsConnections');
  return {
    loading: !gmsConnectionsSub.ready(),
    gmsConnections: TelemetryConnections.find().fetch()
  };
})(NewDBLayerServer);
